import { FormEvent } from 'react'
import { useNavigate } from 'react-router'
import { useDocumentCreate } from '../api/documents'
import { ReservationDocumentForm } from './reservation-document-form'

export function ReservationDocumentCreate() {
	const navigate = useNavigate()
	const { mutate, isPending } = useDocumentCreate()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form), {
			onSuccess: () => {
				form.reset()
				navigate('../')
			},
		})
	}

	return <ReservationDocumentForm onSubmit={onSubmit} isPending={isPending} />
}
